import axios from "axios";
import { corsBypass } from "../constants/enviroments";
import Cookies from "js-cookie";
import { persistor, store } from "../store/store";

let MetisAxios = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? corsBypass : "",
});

MetisAxios.interceptors.request.use(
  async (config) => {
    const cookie_token = Cookies.getItem("qalort_token");
    const token = cookie_token || localStorage.getItem("qalort_token");
    if (token) {
      // config.headers.Authorization = `Bearer ${token}`;
    }
    if (process.env.NODE_ENV === "development") {
      // config.headers["ngrok-skip-browser-warning"] = "lol";
    }
    return config;
  },
  async (error) => {
    throw new Error(error);
  }
);

export const handleAxiosError = (error) => {
  console.log("Axios error:", error.response);

  if (error.response?.status === 401 || error.response?.status === 403) {
    // Get current path excluding the domain
    const currentPath = window.location.pathname + window.location.search;

    // Clear any existing auth tokens
    localStorage.removeItem("qalort_token");
    store.dispatch({ type: "LOGOUT" });
    persistor.purge();
    document.cookie =
      "qalort_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    if (window.location.pathname !== "/login") {
      // Redirect to login with returnUrl
      window.location.href = `/login?returnUrl=${encodeURIComponent(
        currentPath
      )}`;
    }
  }

  return Promise.reject(error);
};

MetisAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle errors globally
    return handleAxiosError(error);
  }
);

export default MetisAxios;
